import React from "react";
import Reveal from "./Reveal";

const Contact = ({ socialLinks }) => {
  const links = [
    {
      label: "E-posta",
      value: socialLinks.email,
      href: `mailto:${socialLinks.email}`,
    },
    {
      label: "GitHub",
      value: "github.com/MucahitTunel",
      href: socialLinks.github,
    },
    {
      label: "LinkedIn",
      value: "linkedin.com/in/mucahittunel",
      href: socialLinks.linkedin,
    },
  ];

  return (
    <section className="act contact" id="contact">
      <div className="act__inner">
        <Reveal>
          <span className="act__num">04 — İletişim</span>
        </Reveal>
        <Reveal as="h2" className="contact__lead" delay={0.05}>
          Bir şeyler <em>inşa edelim</em>
        </Reveal>

        <div className="contact__links">
          {links.map((l, i) => {
            const external = !l.href.startsWith("mailto:");
            return (
              <Reveal
                as="a"
                className="contact__link"
                key={l.label}
                delay={i * 0.06}
                href={l.href}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
              >
                <span className="contact__link-label">{l.label}</span>
                <span className="contact__link-value" lang="en">
                  {l.value}
                </span>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Contact;
